var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4e211;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 760.76,
    cy: 504.97,
    r: 335.69
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bubble_4",
    "data-name": "bubble 4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 760.76,
    cy: 504.97,
    r: 335.69
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M486.9,427.25c-10.71,29.55-15.9,61.69-10.33,92.62s22.76,60.48,49.5,77,63.22,18,89.13.23S652.57,541.6,637.54,514c-8.13-14.93-22.94-26.7-25.89-43.43-4.1-23.23,16.12-43.14,22.81-65.76,7.49-25.34-4.46-55.07-27.4-68.18C543.66,300.39,503.6,381.19,486.9,427.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M926.35,581.1c-12.28,14.11-21.63,31.48-22.92,50.14s6.62,38.52,22.45,48.47c12,7.54,27.24,8.76,41,5.45s26.24-10.76,37.39-19.49c18.86-14.77,35-34.26,41-57.44s.35-50.26-17.94-65.73C990.22,511.06,950,554,926.35,581.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects23);
export default __webpack_public_path__ + "static/media/objects-23.2231b47254158698902e881fb6348af1.svg";
export { ForwardRef as ReactComponent };